import { useState } from 'react';
export function useString() {
    const [string, setString] = useState('');
    const clearString = () => setString('');
    return [string, setString, clearString];
}
